import { render, staticRenderFns } from "./SocialNetworkIcon.vue?vue&type=template&id=812bcd8e&scoped=true&"
import script from "./SocialNetworkIcon.vue?vue&type=script&lang=js&"
export * from "./SocialNetworkIcon.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetworkIcon.vue?vue&type=style&index=0&id=812bcd8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812bcd8e",
  null
  
)

export default component.exports